// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/**
 * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/*
* Ensure proper alignment of the vue material icons
*/
.material-design-icon[data-v-71ced7ce] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
.list-item__wrapper[data-v-71ced7ce] {
  display: flex;
  position: relative;
  width: 100%;
}
.list-item__wrapper--active .list-item[data-v-71ced7ce], .list-item__wrapper.active .list-item[data-v-71ced7ce] {
  background-color: var(--color-primary-element);
}
.list-item__wrapper--active .list-item[data-v-71ced7ce]:hover, .list-item__wrapper--active .list-item[data-v-71ced7ce]:focus-within, .list-item__wrapper--active .list-item[data-v-71ced7ce]:has(:focus-visible), .list-item__wrapper--active .list-item[data-v-71ced7ce]:has(:active), .list-item__wrapper.active .list-item[data-v-71ced7ce]:hover, .list-item__wrapper.active .list-item[data-v-71ced7ce]:focus-within, .list-item__wrapper.active .list-item[data-v-71ced7ce]:has(:focus-visible), .list-item__wrapper.active .list-item[data-v-71ced7ce]:has(:active) {
  background-color: var(--color-primary-element-hover);
}
.list-item__wrapper--active .list-item-content__name[data-v-71ced7ce],
.list-item__wrapper--active .list-item-content__subname[data-v-71ced7ce],
.list-item__wrapper--active .list-item-content__details[data-v-71ced7ce],
.list-item__wrapper--active .list-item-details__details[data-v-71ced7ce], .list-item__wrapper.active .list-item-content__name[data-v-71ced7ce],
.list-item__wrapper.active .list-item-content__subname[data-v-71ced7ce],
.list-item__wrapper.active .list-item-content__details[data-v-71ced7ce],
.list-item__wrapper.active .list-item-details__details[data-v-71ced7ce] {
  color: var(--color-primary-element-text) !important;
}
.list-item__wrapper .list-item-content__name[data-v-71ced7ce],
.list-item__wrapper .list-item-content__subname[data-v-71ced7ce],
.list-item__wrapper .list-item-content__details[data-v-71ced7ce],
.list-item__wrapper .list-item-details__details[data-v-71ced7ce] {
  white-space: nowrap;
  margin: 0 auto 0 0;
  overflow: hidden;
  text-overflow: ellipsis;
}
.list-item-content__name[data-v-71ced7ce] {
  min-width: 100px;
  max-width: 300px;
  flex: 1 1 10%;
  font-weight: 500;
}
.list-item-content__subname[data-v-71ced7ce] {
  flex: 1 0;
  min-width: 0;
  color: var(--color-text-maxcontrast);
}
.list-item-content__subname--bold[data-v-71ced7ce] {
  font-weight: 500;
}
.list-item[data-v-71ced7ce] {
  box-sizing: border-box;
  display: flex;
  position: relative;
  flex: 0 0 auto;
  justify-content: flex-start;
  padding: 8px 10px;
  margin: 4px;
  width: calc(100% - 8px);
  border-radius: var(--border-radius-element, 32px);
  cursor: pointer;
  transition: background-color var(--animation-quick) ease-in-out;
  list-style: none;
}
.list-item[data-v-71ced7ce]:hover, .list-item[data-v-71ced7ce]:focus-within, .list-item[data-v-71ced7ce]:has(:active), .list-item[data-v-71ced7ce]:has(:focus-visible) {
  background-color: var(--color-background-hover);
}
.list-item[data-v-71ced7ce]:has(.list-item__anchor:focus-visible) {
  outline: 2px solid var(--color-main-text);
  box-shadow: 0 0 0 4px var(--color-main-background);
}
.list-item--compact[data-v-71ced7ce] {
  padding: 4px 10px;
}
.list-item--compact .list-item__anchor .line-one[data-v-71ced7ce], .list-item--compact .list-item__anchor .line-two[data-v-71ced7ce] {
  margin-block: -4px;
}
.list-item .list-item-content__details[data-v-71ced7ce] {
  display: flex;
  flex-direction: column;
  justify-content: end;
  align-items: end;
}
.list-item--one-line[data-v-71ced7ce] {
  padding: 0 9px;
  margin: 2px;
}
.list-item--one-line .list-item-content__main[data-v-71ced7ce] {
  display: flex;
  justify-content: start;
  gap: 12px;
  min-width: 0;
}
.list-item--one-line .list-item-content__details[data-v-71ced7ce] {
  flex-direction: row;
  align-items: unset;
  justify-content: end;
}
.list-item__anchor[data-v-71ced7ce] {
  display: flex;
  flex: 1 0 auto;
  align-items: center;
  height: var(--default-clickable-area);
  min-width: 0;
}
.list-item__anchor[data-v-71ced7ce]:focus-visible {
  outline: none;
}
.list-item-content[data-v-71ced7ce] {
  display: flex;
  flex: 1 0;
  justify-content: space-between;
  padding-left: 8px;
  min-width: 0;
}
.list-item-content__main[data-v-71ced7ce] {
  flex: 1 0;
  width: 0;
  margin: auto 0;
}
.list-item-content__main--oneline[data-v-71ced7ce] {
  display: flex;
}
.list-item-content__actions[data-v-71ced7ce] {
  flex: 0 0 auto;
  align-self: center;
  justify-content: center;
  margin-left: 4px;
}
.list-item-details__details[data-v-71ced7ce] {
  color: var(--color-text-maxcontrast);
  margin: 0 9px !important;
  font-weight: normal;
}
.list-item-details__extra[data-v-71ced7ce] {
  margin: 2px 4px 0 4px;
  display: flex;
  align-items: center;
}
.list-item-details__indicator[data-v-71ced7ce] {
  margin: 0 5px;
}
.list-item__extra[data-v-71ced7ce] {
  margin-top: 4px;
}`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/vue/dist/assets/NcListItem-DTaecNLV.css"],"names":[],"mappings":"AAAA;;;EAGE;AACF;;;EAGE;AACF;;CAEC;AACD;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,8CAA8C;AAChD;AACA;EACE,oDAAoD;AACtD;AACA;;;;;;;EAOE,mDAAmD;AACrD;AACA;;;;EAIE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,SAAS;EACT,YAAY;EACZ,oCAAoC;AACtC;AACA;EACE,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,2BAA2B;EAC3B,iBAAiB;EACjB,WAAW;EACX,uBAAuB;EACvB,iDAAiD;EACjD,eAAe;EACf,+DAA+D;EAC/D,gBAAgB;AAClB;AACA;EACE,+CAA+C;AACjD;AACA;EACE,yCAAyC;EACzC,kDAAkD;AACpD;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,WAAW;AACb;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,qCAAqC;EACrC,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,SAAS;EACT,8BAA8B;EAC9B,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,SAAS;EACT,QAAQ;EACR,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,oCAAoC;EACpC,wBAAwB;EACxB,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;AACjB","sourcesContent":["/**\n * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/**\n * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/*\n* Ensure proper alignment of the vue material icons\n*/\n.material-design-icon[data-v-71ced7ce] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n.list-item__wrapper[data-v-71ced7ce] {\n  display: flex;\n  position: relative;\n  width: 100%;\n}\n.list-item__wrapper--active .list-item[data-v-71ced7ce], .list-item__wrapper.active .list-item[data-v-71ced7ce] {\n  background-color: var(--color-primary-element);\n}\n.list-item__wrapper--active .list-item[data-v-71ced7ce]:hover, .list-item__wrapper--active .list-item[data-v-71ced7ce]:focus-within, .list-item__wrapper--active .list-item[data-v-71ced7ce]:has(:focus-visible), .list-item__wrapper--active .list-item[data-v-71ced7ce]:has(:active), .list-item__wrapper.active .list-item[data-v-71ced7ce]:hover, .list-item__wrapper.active .list-item[data-v-71ced7ce]:focus-within, .list-item__wrapper.active .list-item[data-v-71ced7ce]:has(:focus-visible), .list-item__wrapper.active .list-item[data-v-71ced7ce]:has(:active) {\n  background-color: var(--color-primary-element-hover);\n}\n.list-item__wrapper--active .list-item-content__name[data-v-71ced7ce],\n.list-item__wrapper--active .list-item-content__subname[data-v-71ced7ce],\n.list-item__wrapper--active .list-item-content__details[data-v-71ced7ce],\n.list-item__wrapper--active .list-item-details__details[data-v-71ced7ce], .list-item__wrapper.active .list-item-content__name[data-v-71ced7ce],\n.list-item__wrapper.active .list-item-content__subname[data-v-71ced7ce],\n.list-item__wrapper.active .list-item-content__details[data-v-71ced7ce],\n.list-item__wrapper.active .list-item-details__details[data-v-71ced7ce] {\n  color: var(--color-primary-element-text) !important;\n}\n.list-item__wrapper .list-item-content__name[data-v-71ced7ce],\n.list-item__wrapper .list-item-content__subname[data-v-71ced7ce],\n.list-item__wrapper .list-item-content__details[data-v-71ced7ce],\n.list-item__wrapper .list-item-details__details[data-v-71ced7ce] {\n  white-space: nowrap;\n  margin: 0 auto 0 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.list-item-content__name[data-v-71ced7ce] {\n  min-width: 100px;\n  max-width: 300px;\n  flex: 1 1 10%;\n  font-weight: 500;\n}\n.list-item-content__subname[data-v-71ced7ce] {\n  flex: 1 0;\n  min-width: 0;\n  color: var(--color-text-maxcontrast);\n}\n.list-item-content__subname--bold[data-v-71ced7ce] {\n  font-weight: 500;\n}\n.list-item[data-v-71ced7ce] {\n  box-sizing: border-box;\n  display: flex;\n  position: relative;\n  flex: 0 0 auto;\n  justify-content: flex-start;\n  padding: 8px 10px;\n  margin: 4px;\n  width: calc(100% - 8px);\n  border-radius: var(--border-radius-element, 32px);\n  cursor: pointer;\n  transition: background-color var(--animation-quick) ease-in-out;\n  list-style: none;\n}\n.list-item[data-v-71ced7ce]:hover, .list-item[data-v-71ced7ce]:focus-within, .list-item[data-v-71ced7ce]:has(:active), .list-item[data-v-71ced7ce]:has(:focus-visible) {\n  background-color: var(--color-background-hover);\n}\n.list-item[data-v-71ced7ce]:has(.list-item__anchor:focus-visible) {\n  outline: 2px solid var(--color-main-text);\n  box-shadow: 0 0 0 4px var(--color-main-background);\n}\n.list-item--compact[data-v-71ced7ce] {\n  padding: 4px 10px;\n}\n.list-item--compact .list-item__anchor .line-one[data-v-71ced7ce], .list-item--compact .list-item__anchor .line-two[data-v-71ced7ce] {\n  margin-block: -4px;\n}\n.list-item .list-item-content__details[data-v-71ced7ce] {\n  display: flex;\n  flex-direction: column;\n  justify-content: end;\n  align-items: end;\n}\n.list-item--one-line[data-v-71ced7ce] {\n  padding: 0 9px;\n  margin: 2px;\n}\n.list-item--one-line .list-item-content__main[data-v-71ced7ce] {\n  display: flex;\n  justify-content: start;\n  gap: 12px;\n  min-width: 0;\n}\n.list-item--one-line .list-item-content__details[data-v-71ced7ce] {\n  flex-direction: row;\n  align-items: unset;\n  justify-content: end;\n}\n.list-item__anchor[data-v-71ced7ce] {\n  display: flex;\n  flex: 1 0 auto;\n  align-items: center;\n  height: var(--default-clickable-area);\n  min-width: 0;\n}\n.list-item__anchor[data-v-71ced7ce]:focus-visible {\n  outline: none;\n}\n.list-item-content[data-v-71ced7ce] {\n  display: flex;\n  flex: 1 0;\n  justify-content: space-between;\n  padding-left: 8px;\n  min-width: 0;\n}\n.list-item-content__main[data-v-71ced7ce] {\n  flex: 1 0;\n  width: 0;\n  margin: auto 0;\n}\n.list-item-content__main--oneline[data-v-71ced7ce] {\n  display: flex;\n}\n.list-item-content__actions[data-v-71ced7ce] {\n  flex: 0 0 auto;\n  align-self: center;\n  justify-content: center;\n  margin-left: 4px;\n}\n.list-item-details__details[data-v-71ced7ce] {\n  color: var(--color-text-maxcontrast);\n  margin: 0 9px !important;\n  font-weight: normal;\n}\n.list-item-details__extra[data-v-71ced7ce] {\n  margin: 2px 4px 0 4px;\n  display: flex;\n  align-items: center;\n}\n.list-item-details__indicator[data-v-71ced7ce] {\n  margin: 0 5px;\n}\n.list-item__extra[data-v-71ced7ce] {\n  margin-top: 4px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
